// eslint-disable-next-line import/no-extraneous-dependencies
import _ from 'lodash';
import Users from '../schemas/public/Users';
import UserType from '../schemas/public/UserType';
import { ExerciseType } from '../models/ExerciseType';

const imageKitBaseUrl = 'https://ik.imagekit.io/ttd0gzik4ov'; // use "ttd0gzik4ovDEV" or DEV2 for dev
const firebaseStorageBaseUrl = 'https://firebasestorage.googleapis.com';

/** A width alone keeps the photo's proportions (no crop); width and height fill that box. */
const imageKitTransformOf = (width?: number, height?: number): string => {
    if (!width) return 'tr:f-jpg';
    return height ? `tr:w-${width},h-${height},f-jpg` : `tr:w-${width},f-jpg`;
};

export const getImageKitUrlFrom = (url: string, width?: number, height?: number): string => {
    if (!url) return '';
    return url.replace(
        firebaseStorageBaseUrl,
        `${imageKitBaseUrl}/${imageKitTransformOf(width, height)}`
    );
};

/**
 * Low-quality image placeholder (LQIP) URL — small, blurred, low quality.
 * Loads near-instantly and is meant to be displayed behind the HD image
 * while the HD version is downloading.
 */
export const getImageKitLqipUrl = (url: string): string => {
    if (!url) return '';
    return url.replace(firebaseStorageBaseUrl, `${imageKitBaseUrl}/tr:w-40,bl-30,q-20,f-jpg`);
};

export const getImageKitUrlFromRounded = (url: string, width?: number, height?: number): string => {
    if (width && height) {
        return url.replace(
            firebaseStorageBaseUrl,
            `${imageKitBaseUrl}/tr:w-${width},h-${height},r-max`
        );
    }
    return url.replace(firebaseStorageBaseUrl, imageKitBaseUrl);
};

export const validateEmail = (emailReceived: string | null): boolean => {
    const emailRegex =
        /^(([^<>()[\]\\.,;:\s@\\"]+(\.[^<>()[\]\\.,;:\s@\\"]+)*)|(\\".+\\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if (emailReceived && emailReceived.trim() !== '') {
        return emailRegex.test(emailReceived);
    }
    return false;
};

// export const YoutubeAPIKey = 'AIzaSyAr9CT1rhhTBnOfTQyM3YNGoBvsk46s_Lk'; // PROD
// export const YoutubeAPIKey = 'AIzaSyBR1Den86CcKYvU3lT27lAvVMG8ED5aqsg'; // DEV

export const getCommunityId = (user: Users | null | undefined): string | null => {
    if (user && user.id) {
        if (user.type === UserType.FAMILY || user.type === UserType.USER) {
            if (user.familyId) {
                return user.familyId;
            }
        }
        if (user.type === UserType.PRO) {
            if (user.establishmentId) {
                return user.establishmentId;
            }
        }
        if (user.type === UserType.ADMIN) {
            return user.id;
        }
    }
    return null;
};

const getMultipleRandom = (arr: number[], num: number): number[] => {
    const shuffled = [...arr].sort(() => 0.5 - Math.random());

    return shuffled.slice(0, num);
};

export const randomPicture = (level: number, exoType: ExerciseType): number[] => {
    const arrayLvlToPicture = {
        "PUZZL'IN": [0],
        "SOUVEN'IN": [3, 4, 4, 4, 6, 4, 5, 5, 6, 6],
        "MEMOR'IN": [2, 3, 4, 5, 6, 8, 10, 12, 15, 18],
        "SUDOK'IN": [0],
        "PONG'IN": [0],
        "ORDON'IN": [0],
        TOURBILLON: [0],
        "MELI'MELO": [0]
    };
    let list: number[] = [];
    let array: number[];
    if (exoType === ExerciseType.MEMORIZ) {
        array = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17];
    } else {
        array = [0, 1, 2, 3, 4, 5];
    }
    list = getMultipleRandom(
        array,
        arrayLvlToPicture[exoType as keyof typeof arrayLvlToPicture][level - 1]
    );

    return list;
};
